import styled from 'styled-components'
import {backgroundColor2, fontSize2} from '../Shared/Style'

export default styled.select`
    ${backgroundColor2};
    ${fontSize2};
    color: #1163c9;
    padding: 5px;
    border-radius: 10px;
    float: right;
`